import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { getSettingsActions } from '../../../redux/slices/getSettingsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetSettings = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onSettingInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onSettingInfoSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        dispatch(getSettingsActions.setSettingsData(data));
    };

    const getSettings = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/settings`,
            method: 'get',
        };

        return request(url, onSettingInfoSuccess, setLoading, onSettingInfoError);
    };

    return { getSettings, loading };
};

export default useGetSettings;
